import {useEffect, useReducer} from 'react';
import {UserCredential, User, ApplicationVerifier, ConfirmationResult} from '@firebase/auth-types';

import reducer, {initialState, CurrentUser} from './reducer';

import {firebaseAuth} from '../../externals';

export interface IAuthenticator {
  currentUser: CurrentUser
  isInitialized: boolean
  signInWithEmailPassword: (email: string, password: string) => Promise<UserCredential>
  sendPasswordResetEmail: (email: string) => void
  signInWithPhoneNumber: (phone: string, appVerifier: ApplicationVerifier) => Promise<ConfirmationResult>
  signOut: () => void
}

type FirebaseCallback = (user: User | null) => void

//Q: why we need to useReducer here? A: we need batch update for smooth state

function useFirebaseAuth(onAuthChanged?: FirebaseCallback): IAuthenticator {
  const [{currentUser, isInitialized}, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    firebaseAuth.onAuthStateChanged(async (user: User | null) => {
      if (onAuthChanged) {
        await onAuthChanged(user)
      }
      dispatch({type: 'SET_CURRENT_USER', payload: user});
    });
    //eslint-disable-next-line
  }, []);

  return {
    currentUser,
    isInitialized,
    signInWithEmailPassword: firebaseAuth.signInWithEmailAndPassword,
    sendPasswordResetEmail: firebaseAuth.sendPasswordResetEmail,
    signInWithPhoneNumber: firebaseAuth.signInWithPhoneNumber,
    signOut: firebaseAuth.signOut
  }
}

export default useFirebaseAuth
